import { render, staticRenderFns } from "./OtherRequests.vue?vue&type=template&id=3f8cf148&scoped=true&"
import script from "./OtherRequests.vue?vue&type=script&lang=js&"
export * from "./OtherRequests.vue?vue&type=script&lang=js&"
import style0 from "./OtherRequests.vue?vue&type=style&index=0&id=3f8cf148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8cf148",
  null
  
)

export default component.exports